import React from "react";
import '../../assets/css/Bump/Content.css';

const NotFoundContent = () => {
    return (
        <>
            <div className="mainContainer">
                <h2>Derniers Bumps</h2>
                <h4>Voici la liste des derniers serveurs bump (boostés), pour apparaitre ici,<br />vous pouvez executer la commande <code>/bump</code>, qui boostera votre serveur, et vous apparaitrez ici instantanément après !</h4>
                <p>&gt;&gt; Cliquez sur un serveur pour le rejoindre.</p>
                <div className="boosted-guilds">
                    <div className="container">

                        {/* Début du premier element */}
                        <button className="guild-card" onClick={() => alert('Loading... Please Wait...')}>
                                <div className="skeleton-loader" style={{ width: '75px', height: '75px', borderRadius: '50px' }}></div>
                                <blockquote cite="https://discord.gg/ctJCjbP3Qd">
                                    <div className="skeleton-loader" style={{ width: '310px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '210px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '275px', height: '20px' }}></div>
                                </blockquote>
                                <p className="guild-info">
                                    <div className="skeleton-loader" style={{ width: '310px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '200px', height: '20px' }}></div>
                                </p>
                            </button>
                        {/* Fin du premier element */}

                        {/* Début du premier element */}
                        <button className="guild-card" onClick={() => alert('Loading... Please Wait...')}>
                                <div className="skeleton-loader" style={{ width: '75px', height: '75px', borderRadius: '50px' }}></div>
                                <blockquote cite="https://discord.gg/ctJCjbP3Qd">
                                    <div className="skeleton-loader" style={{ width: '310px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '210px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '275px', height: '20px' }}></div>
                                </blockquote>
                                <p className="guild-info">
                                    <div className="skeleton-loader" style={{ width: '310px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '200px', height: '20px' }}></div>
                                </p>
                            </button>
                        {/* Fin du premier element */}

                        {/* Début du premier element */}
                        <button className="guild-card" onClick={() => alert('Loading... Please Wait...')}>
                                <div className="skeleton-loader" style={{ width: '75px', height: '75px', borderRadius: '50px' }}></div>
                                <blockquote cite="https://discord.gg/ctJCjbP3Qd">
                                    <div className="skeleton-loader" style={{ width: '310px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '210px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '275px', height: '20px' }}></div>
                                </blockquote>
                                <p className="guild-info">
                                    <div className="skeleton-loader" style={{ width: '310px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '200px', height: '20px' }}></div>
                                </p>
                            </button>
                        {/* Fin du premier element */}

                        {/* Début du premier element */}
                        <button className="guild-card" onClick={() => alert('Loading... Please Wait...')}>
                                <div className="skeleton-loader" style={{ width: '75px', height: '75px', borderRadius: '50px' }}></div>
                                <blockquote cite="https://discord.gg/ctJCjbP3Qd">
                                    <div className="skeleton-loader" style={{ width: '310px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '210px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '275px', height: '20px' }}></div>
                                </blockquote>
                                <p className="guild-info">
                                    <div className="skeleton-loader" style={{ width: '310px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '200px', height: '20px' }}></div>
                                </p>
                            </button>
                        {/* Fin du premier element */}

                        {/* Début du premier element */}
                        <button className="guild-card" onClick={() => alert('Loading... Please Wait...')}>
                                <div className="skeleton-loader" style={{ width: '75px', height: '75px', borderRadius: '50px' }}></div>
                                <blockquote cite="https://discord.gg/ctJCjbP3Qd">
                                    <div className="skeleton-loader" style={{ width: '310px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '210px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '275px', height: '20px' }}></div>
                                </blockquote>
                                <p className="guild-info">
                                    <div className="skeleton-loader" style={{ width: '310px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '200px', height: '20px' }}></div>
                                </p>
                            </button>
                        {/* Fin du premier element */}

                        {/* Début du premier element */}
                        <button className="guild-card" onClick={() => alert('Loading... Please Wait...')}>
                                <div className="skeleton-loader" style={{ width: '75px', height: '75px', borderRadius: '50px' }}></div>
                                <blockquote cite="https://discord.gg/ctJCjbP3Qd">
                                    <div className="skeleton-loader" style={{ width: '310px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '210px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '275px', height: '20px' }}></div>
                                </blockquote>
                                <p className="guild-info">
                                    <div className="skeleton-loader" style={{ width: '310px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '200px', height: '20px' }}></div>
                                </p>
                            </button>
                        {/* Fin du premier element */}

                        {/* Début du premier element */}
                        <button className="guild-card" onClick={() => alert('Loading... Please Wait...')}>
                                <div className="skeleton-loader" style={{ width: '75px', height: '75px', borderRadius: '50px' }}></div>
                                <blockquote cite="https://discord.gg/ctJCjbP3Qd">
                                    <div className="skeleton-loader" style={{ width: '310px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '210px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '275px', height: '20px' }}></div>
                                </blockquote>
                                <p className="guild-info">
                                    <div className="skeleton-loader" style={{ width: '310px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '200px', height: '20px' }}></div>
                                </p>
                            </button>
                        {/* Fin du premier element */}

                        {/* Début du premier element */}
                        <button className="guild-card" onClick={() => alert('Loading... Please Wait...')}>
                                <div className="skeleton-loader" style={{ width: '75px', height: '75px', borderRadius: '50px' }}></div>
                                <blockquote cite="https://discord.gg/ctJCjbP3Qd">
                                    <div className="skeleton-loader" style={{ width: '310px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '210px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '275px', height: '20px' }}></div>
                                </blockquote>
                                <p className="guild-info">
                                    <div className="skeleton-loader" style={{ width: '310px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '200px', height: '20px' }}></div>
                                </p>
                            </button>
                        {/* Fin du premier element */}

                        {/* Début du premier element */}
                        <button className="guild-card" onClick={() => alert('Loading... Please Wait...')}>
                                <div className="skeleton-loader" style={{ width: '75px', height: '75px', borderRadius: '50px' }}></div>
                                <blockquote cite="https://discord.gg/ctJCjbP3Qd">
                                    <div className="skeleton-loader" style={{ width: '310px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '210px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '275px', height: '20px' }}></div>
                                </blockquote>
                                <p className="guild-info">
                                    <div className="skeleton-loader" style={{ width: '310px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '200px', height: '20px' }}></div>
                                </p>
                            </button>
                        {/* Fin du premier element */}

                        {/* Début du premier element */}
                        <button className="guild-card" onClick={() => alert('Loading... Please Wait...')}>
                                <div className="skeleton-loader" style={{ width: '75px', height: '75px', borderRadius: '50px' }}></div>
                                <blockquote cite="https://discord.gg/ctJCjbP3Qd">
                                    <div className="skeleton-loader" style={{ width: '310px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '210px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '275px', height: '20px' }}></div>
                                </blockquote>
                                <p className="guild-info">
                                    <div className="skeleton-loader" style={{ width: '310px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '200px', height: '20px' }}></div>
                                </p>
                            </button>
                        {/* Fin du premier element */}

                        {/* Début du premier element */}
                        <button className="guild-card" onClick={() => alert('Loading... Please Wait...')}>
                                <div className="skeleton-loader" style={{ width: '75px', height: '75px', borderRadius: '50px' }}></div>
                                <blockquote cite="https://discord.gg/ctJCjbP3Qd">
                                    <div className="skeleton-loader" style={{ width: '310px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '210px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '275px', height: '20px' }}></div>
                                </blockquote>
                                <p className="guild-info">
                                    <div className="skeleton-loader" style={{ width: '310px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '200px', height: '20px' }}></div>
                                </p>
                            </button>
                        {/* Fin du premier element */}

                        {/* Début du premier element */}
                        <button className="guild-card" onClick={() => alert('Loading... Please Wait...')}>
                                <div className="skeleton-loader" style={{ width: '75px', height: '75px', borderRadius: '50px' }}></div>
                                <blockquote cite="https://discord.gg/ctJCjbP3Qd">
                                    <div className="skeleton-loader" style={{ width: '310px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '210px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '275px', height: '20px' }}></div>
                                </blockquote>
                                <p className="guild-info">
                                    <div className="skeleton-loader" style={{ width: '310px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '200px', height: '20px' }}></div>
                                </p>
                            </button>
                        {/* Fin du premier element */}

                        {/* Début du premier element */}
                        <button className="guild-card" onClick={() => alert('Loading... Please Wait...')}>
                                <div className="skeleton-loader" style={{ width: '75px', height: '75px', borderRadius: '50px' }}></div>
                                <blockquote cite="https://discord.gg/ctJCjbP3Qd">
                                    <div className="skeleton-loader" style={{ width: '310px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '210px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '275px', height: '20px' }}></div>
                                </blockquote>
                                <p className="guild-info">
                                    <div className="skeleton-loader" style={{ width: '310px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '200px', height: '20px' }}></div>
                                </p>
                            </button>
                        {/* Fin du premier element */}

                        {/* Début du premier element */}
                        <button className="guild-card" onClick={() => alert('Loading... Please Wait...')}>
                                <div className="skeleton-loader" style={{ width: '75px', height: '75px', borderRadius: '50px' }}></div>
                                <blockquote cite="https://discord.gg/ctJCjbP3Qd">
                                    <div className="skeleton-loader" style={{ width: '310px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '210px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '275px', height: '20px' }}></div>
                                </blockquote>
                                <p className="guild-info">
                                    <div className="skeleton-loader" style={{ width: '310px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '200px', height: '20px' }}></div>
                                </p>
                            </button>
                        {/* Fin du premier element */}

                        {/* Début du premier element */}
                        <button className="guild-card" onClick={() => alert('Loading... Please Wait...')}>
                                <div className="skeleton-loader" style={{ width: '75px', height: '75px', borderRadius: '50px' }}></div>
                                <blockquote cite="https://discord.gg/ctJCjbP3Qd">
                                    <div className="skeleton-loader" style={{ width: '310px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '210px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '275px', height: '20px' }}></div>
                                </blockquote>
                                <p className="guild-info">
                                    <div className="skeleton-loader" style={{ width: '310px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '200px', height: '20px' }}></div>
                                </p>
                            </button>
                        {/* Fin du premier element */}

                        {/* Début du premier element */}
                        <button className="guild-card" onClick={() => alert('Loading... Please Wait...')}>
                                <div className="skeleton-loader" style={{ width: '75px', height: '75px', borderRadius: '50px' }}></div>
                                <blockquote cite="https://discord.gg/ctJCjbP3Qd">
                                    <div className="skeleton-loader" style={{ width: '310px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '210px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '275px', height: '20px' }}></div>
                                </blockquote>
                                <p className="guild-info">
                                    <div className="skeleton-loader" style={{ width: '310px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '200px', height: '20px' }}></div>
                                </p>
                            </button>
                        {/* Fin du premier element */}

                        {/* Début du premier element */}
                        <button className="guild-card" onClick={() => alert('Loading... Please Wait...')}>
                                <div className="skeleton-loader" style={{ width: '75px', height: '75px', borderRadius: '50px' }}></div>
                                <blockquote cite="https://discord.gg/ctJCjbP3Qd">
                                    <div className="skeleton-loader" style={{ width: '310px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '210px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '275px', height: '20px' }}></div>
                                </blockquote>
                                <p className="guild-info">
                                    <div className="skeleton-loader" style={{ width: '310px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '200px', height: '20px' }}></div>
                                </p>
                            </button>
                        {/* Fin du premier element */}

                        {/* Début du premier element */}
                        <button className="guild-card" onClick={() => alert('Loading... Please Wait...')}>
                                <div className="skeleton-loader" style={{ width: '75px', height: '75px', borderRadius: '50px' }}></div>
                                <blockquote cite="https://discord.gg/ctJCjbP3Qd">
                                    <div className="skeleton-loader" style={{ width: '310px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '210px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '275px', height: '20px' }}></div>
                                </blockquote>
                                <p className="guild-info">
                                    <div className="skeleton-loader" style={{ width: '310px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '200px', height: '20px' }}></div>
                                </p>
                            </button>
                        {/* Fin du premier element */}

                        {/* Début du premier element */}
                        <button className="guild-card" onClick={() => alert('Loading... Please Wait...')}>
                                <div className="skeleton-loader" style={{ width: '75px', height: '75px', borderRadius: '50px' }}></div>
                                <blockquote cite="https://discord.gg/ctJCjbP3Qd">
                                    <div className="skeleton-loader" style={{ width: '310px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '210px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '275px', height: '20px' }}></div>
                                </blockquote>
                                <p className="guild-info">
                                    <div className="skeleton-loader" style={{ width: '310px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '200px', height: '20px' }}></div>
                                </p>
                            </button>
                        {/* Fin du premier element */}

                        {/* Début du premier element */}
                        <button className="guild-card" onClick={() => alert('Loading... Please Wait...')}>
                                <div className="skeleton-loader" style={{ width: '75px', height: '75px', borderRadius: '50px' }}></div>
                                <blockquote cite="https://discord.gg/ctJCjbP3Qd">
                                    <div className="skeleton-loader" style={{ width: '310px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '210px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '275px', height: '20px' }}></div>
                                </blockquote>
                                <p className="guild-info">
                                    <div className="skeleton-loader" style={{ width: '310px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '200px', height: '20px' }}></div>
                                </p>
                            </button>
                        {/* Fin du premier element */}

                        {/* Début du premier element */}
                        <button className="guild-card" onClick={() => alert('Loading... Please Wait...')}>
                                <div className="skeleton-loader" style={{ width: '75px', height: '75px', borderRadius: '50px' }}></div>
                                <blockquote cite="https://discord.gg/ctJCjbP3Qd">
                                    <div className="skeleton-loader" style={{ width: '310px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '210px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '275px', height: '20px' }}></div>
                                </blockquote>
                                <p className="guild-info">
                                    <div className="skeleton-loader" style={{ width: '310px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '200px', height: '20px' }}></div>
                                </p>
                            </button>
                        {/* Fin du premier element */}

                        {/* Début du premier element */}
                        <button className="guild-card" onClick={() => alert('Loading... Please Wait...')}>
                                <div className="skeleton-loader" style={{ width: '75px', height: '75px', borderRadius: '50px' }}></div>
                                <blockquote cite="https://discord.gg/ctJCjbP3Qd">
                                    <div className="skeleton-loader" style={{ width: '310px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '210px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '275px', height: '20px' }}></div>
                                </blockquote>
                                <p className="guild-info">
                                    <div className="skeleton-loader" style={{ width: '310px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '200px', height: '20px' }}></div>
                                </p>
                            </button>
                        {/* Fin du premier element */}

                        {/* Début du premier element */}
                        <button className="guild-card" onClick={() => alert('Loading... Please Wait...')}>
                                <div className="skeleton-loader" style={{ width: '75px', height: '75px', borderRadius: '50px' }}></div>
                                <blockquote cite="https://discord.gg/ctJCjbP3Qd">
                                    <div className="skeleton-loader" style={{ width: '310px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '210px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '275px', height: '20px' }}></div>
                                </blockquote>
                                <p className="guild-info">
                                    <div className="skeleton-loader" style={{ width: '310px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '200px', height: '20px' }}></div>
                                </p>
                            </button>
                        {/* Fin du premier element */}

                        {/* Début du premier element */}
                        <button className="guild-card" onClick={() => alert('Loading... Please Wait...')}>
                                <div className="skeleton-loader" style={{ width: '75px', height: '75px', borderRadius: '50px' }}></div>
                                <blockquote cite="https://discord.gg/ctJCjbP3Qd">
                                    <div className="skeleton-loader" style={{ width: '310px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '210px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '275px', height: '20px' }}></div>
                                </blockquote>
                                <p className="guild-info">
                                    <div className="skeleton-loader" style={{ width: '310px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '200px', height: '20px' }}></div>
                                </p>
                            </button>
                        {/* Fin du premier element */}

                        {/* Début du premier element */}
                        <button className="guild-card" onClick={() => alert('Loading... Please Wait...')}>
                                <div className="skeleton-loader" style={{ width: '75px', height: '75px', borderRadius: '50px' }}></div>
                                <blockquote cite="https://discord.gg/ctJCjbP3Qd">
                                    <div className="skeleton-loader" style={{ width: '310px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '210px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '275px', height: '20px' }}></div>
                                </blockquote>
                                <p className="guild-info">
                                    <div className="skeleton-loader" style={{ width: '310px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '200px', height: '20px' }}></div>
                                </p>
                            </button>
                        {/* Fin du premier element */}

                        {/* Début du premier element */}
                        <button className="guild-card" onClick={() => alert('Loading... Please Wait...')}>
                                <div className="skeleton-loader" style={{ width: '75px', height: '75px', borderRadius: '50px' }}></div>
                                <blockquote cite="https://discord.gg/ctJCjbP3Qd">
                                    <div className="skeleton-loader" style={{ width: '310px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '210px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '275px', height: '20px' }}></div>
                                </blockquote>
                                <p className="guild-info">
                                    <div className="skeleton-loader" style={{ width: '310px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '200px', height: '20px' }}></div>
                                </p>
                            </button>
                        {/* Fin du premier element */}

                        {/* Début du premier element */}
                        <button className="guild-card" onClick={() => alert('Loading... Please Wait...')}>
                                <div className="skeleton-loader" style={{ width: '75px', height: '75px', borderRadius: '50px' }}></div>
                                <blockquote cite="https://discord.gg/ctJCjbP3Qd">
                                    <div className="skeleton-loader" style={{ width: '310px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '210px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '275px', height: '20px' }}></div>
                                </blockquote>
                                <p className="guild-info">
                                    <div className="skeleton-loader" style={{ width: '310px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '200px', height: '20px' }}></div>
                                </p>
                            </button>
                        {/* Fin du premier element */}

                        {/* Début du premier element */}
                        <button className="guild-card" onClick={() => alert('Loading... Please Wait...')}>
                                <div className="skeleton-loader" style={{ width: '75px', height: '75px', borderRadius: '50px' }}></div>
                                <blockquote cite="https://discord.gg/ctJCjbP3Qd">
                                    <div className="skeleton-loader" style={{ width: '310px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '210px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '275px', height: '20px' }}></div>
                                </blockquote>
                                <p className="guild-info">
                                    <div className="skeleton-loader" style={{ width: '310px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '200px', height: '20px' }}></div>
                                </p>
                            </button>
                        {/* Fin du premier element */}

                        {/* Début du premier element */}
                        <button className="guild-card" onClick={() => alert('Loading... Please Wait...')}>
                                <div className="skeleton-loader" style={{ width: '75px', height: '75px', borderRadius: '50px' }}></div>
                                <blockquote cite="https://discord.gg/ctJCjbP3Qd">
                                    <div className="skeleton-loader" style={{ width: '310px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '210px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '275px', height: '20px' }}></div>
                                </blockquote>
                                <p className="guild-info">
                                    <div className="skeleton-loader" style={{ width: '310px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '200px', height: '20px' }}></div>
                                </p>
                            </button>
                        {/* Fin du premier element */}

                        {/* Début du premier element */}
                        <button className="guild-card" onClick={() => alert('Loading... Please Wait...')}>
                                <div className="skeleton-loader" style={{ width: '75px', height: '75px', borderRadius: '50px' }}></div>
                                <blockquote cite="https://discord.gg/ctJCjbP3Qd">
                                    <div className="skeleton-loader" style={{ width: '310px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '210px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '275px', height: '20px' }}></div>
                                </blockquote>
                                <p className="guild-info">
                                    <div className="skeleton-loader" style={{ width: '310px', height: '20px' }}></div>
                                    <div className="space"></div>
                                    <div className="skeleton-loader" style={{ width: '200px', height: '20px' }}></div>
                                </p>
                            </button>
                        {/* Fin du premier element */}

                    </div>
                </div>
            </div>
        </>
    );
};

export default NotFoundContent;
